import { memo } from 'react';
import { Flex } from '@chakra-ui/react';

import DashboardIcon from 'components/Icons/DashboardIcon';
import BlocksIcon from 'components/Icons/BlocksIcon';
import DimensionsIcon from 'components/Icons/DimensionsIcon';
import ImportDataIcon from 'components/Icons/ImportDataIcon';

import { TabType } from '../types';
import { MENU_ITEMS, HEADER_CONFIG } from '../constants';

import NavigationButton from './NavigationButton';
import NavigationMenu from './NavigationMenu';

interface NavigationBarProperties {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

const NavigationBar = memo(({ activeTab, onTabChange }: NavigationBarProperties) => {
  return (
    <Flex
      alignItems='center'
      width='fit-content'
      height={HEADER_CONFIG.NAVIGATION_HEIGHT}
      bg='white'
      borderRadius='full'
      flexWrap='nowrap'
      overflow='hidden'
      border='1px solid #D9D9D9'
    >
      <NavigationButton
        icon={DashboardIcon}
        label='Dashboard'
        isActive={activeTab === 'dashboard'}
        onClick={() => onTabChange('dashboard')}
      />

      <NavigationMenu
        icon={BlocksIcon}
        label='Blocks'
        isActive={activeTab === 'blocks'}
        onClick={() => onTabChange('blocks')}
        menuItems={MENU_ITEMS.blocks}
      />

      <NavigationMenu
        icon={DimensionsIcon}
        label='Dimensions'
        isActive={activeTab === 'dimensions'}
        onClick={() => onTabChange('dimensions')}
        menuItems={MENU_ITEMS.dimensions}
      />

      <NavigationMenu
        icon={ImportDataIcon}
        label='Data'
        isActive={activeTab === 'import'}
        onClick={() => onTabChange('import')}
        menuItems={MENU_ITEMS.import}
      />
    </Flex>
  );
});

NavigationBar.displayName = 'NavigationBar';

export default NavigationBar;
